
export const fetch_ILS_planDetail_spanish = (productIdArray,yearValue) => {
   let detailData=[];
   /* @ detailLists is a Object contains plan details/comparision data for ILS for 2024 & 2025, 
    In future respective year Data to be added here, 
    And previous year data if not needed , 
    Can be removed*/
   const detailLists= {
    "2024":{
    ISNP: [
      {
        category: "Descripción general del plan",
        description: [
          [
            "Prima mensual del plan: $ 37.70",
            "Deducible: $0",
            "Desembolso máximo anual: límite anual de $3400 para los servicios que recibe en -proveedores de la red",
          ],
        ],
      },
      {
        category: "Beneficios suplementarios",
        description: [
          [
            "Dental: $3,500",
            "Examen de la vista de rutina (cada 12 meses): N/A",
            "Audífonos: 20 % de coseguro",
            "Beneficio de acondicionamiento físico Silver&Fit®: N/A",
            "Atención quiropráctica: 20 % de coseguro",
            "Acupuntura: N/A",
            "Artículos de venta libre (OTC): hasta $365 por trimestre",
          ],
        ],
      },
      {
        category: "Visitas al médico",
        description: [
          [
            "Visita al médico de atención primaria: $0",
            "Visita al especialista: 20 % de coseguro",
            "Atención preventiva: $0",
            "Servicios de laboratorio/rayos X: 20% de coseguro",
            "Radiología de diagnóstico (p. ej., resonancias magnéticas): 20% de coseguro",
          ],
        ],
      },
      {
        category: "Visitas al hospital y emergencias",
        description: [
          [
            'Cobertura hospitalaria para pacientes internados: deducible de $1600 Días 1 - 60 $0 de copago Días 61 - 90 $400 de copago por día  Días 91 más allá del copago de $800 por cada "día de reserva de por vida" después del día 90 para cada período de beneficios (hasta 60 días durante su vida).  Beyone días de reserva de por vida; todos los costos',
            "Cobertura hospitalaria para pacientes ambulatorios: 20% de coseguro",
            "Atención de emergencia: 20% de coseguro (hasta $120 por visita)",
            "Servicios de urgencia: $30 ($90 para atención de urgencia y cobertura de emergencia a nivel mundial) ",
          ],
        ],
      },
      {
        category: "Medicamentos de Medicare Parte D: cobertura inicial",
        description: [["Venta minorista/correo:", "Nivel 1: $0/$1.55/$4.50"]],
      },
    ],
    ESNP: [
      {
        category: "Descripción general del plan",
        description: [
          [
            "Prima mensual del plan: $ 37.70",
            "Deducible: $0",
            "Desembolso máximo anual: límite anual de $3400 para los servicios que recibe en -proveedores de la red",
          ],
        ],
      },
      {
        category: "Beneficios suplementarios",
        description: [
          [
            "Dental: $3,500",
            "Examen de la vista de rutina (cada 12 meses): N/A",
            "Audífonos: 20 % de coseguro",
            "Beneficio de acondicionamiento físico Silver&Fit®: N/A",
            "Atención quiropráctica: 20 % de coseguro",
            "Acupuntura: N/A",
            "Artículos de venta libre (OTC): hasta $275 por trimestre",
          ],
        ],
      },
      {
        category: "Visitas al médico",
        description: [
          [
            "Visita al médico de atención primaria: $0",
            "Visita al especialista: 20 % de coseguro",
            "Atención preventiva: $0",
            "Servicios de laboratorio/rayos X: 20% de coseguro",
            "Radiología de diagnóstico (p. ej., resonancias magnéticas): 20% de coseguro",
          ],
        ],
      },
      {
        category: "Visitas al hospital y emergencias",
        description: [
          [
            'Cobertura hospitalaria para pacientes internados: deducible de $1600 Días 1 - 60 $0 de copago Días 61 - 90 $400 de copago por día  Días 91 más allá del copago de $800 por cada "día de reserva de por vida" después del día 90 para cada período de beneficios (hasta 60 días durante su vida).  Beyone días de reserva de por vida; todos los costos',
            "Cobertura hospitalaria para pacientes ambulatorios: 20% de coseguro",
            "Atención de emergencia: 20% de coseguro (hasta $120 por visita)",
            "Servicios de urgencia: $30 ($90 para atención de urgencia y cobertura de emergencia a nivel mundial) ",
          ],
        ],
      },
      {
        category: "Medicamentos de Medicare Parte D: cobertura inicial",
        description: [["Venta minorista/correo:", "Nivel 1: $0/$1.55/$4.50"]],
      },
    ],
    DSNP: [
      {
        category: "Descripción general del plan",
        description: [
          [
            "Prima mensual del plan: $0",
            "Deducible: $0",
            "Desembolso máximo anual: $0",
          ],
        ],
      },
      {
        category: "Beneficios suplementarios",
        description: [
          [
            "Dental: asignación de 3500 por año",
            "Examen de la vista de rutina (cada 12 meses): $0",
            "Audífonos: $0",
            "Beneficio de acondicionamiento físico Silver&Fit®: N/A ",
            "Atención quiropráctica: $0",
            "Acupuntura: $0",
            "Artículos de venta libre (OTC): hasta $275 por trimestre",
          ],
        ],
      },
      {
        category: "Visitas al médico",
        description: [
          [
            "Visita al médico de atención primaria: $0",
            "Visita al especialista: $0",
            "Atención preventiva: $0",
            "Servicios de laboratorio/rayos X: $0",
            "Radiología de diagnóstico (p. ej., resonancias magnéticas): $0",
          ],
        ],
      },
      {
        category: "Visitas al hospital y emergencias",
        description: [
          [
            "Cobertura hospitalaria para pacientes internados: $0",
            "Cobertura hospitalaria para pacientes ambulatorios: $0",
            "Atención de emergencia: $0",
            "Servicios de urgencia: $0",
          ],
        ],
      },
      {
        category: "Medicamentos de Medicare Parte D: cobertura inicial",
        description: [["Venta minorista/por correo:", "Nivel 1: $0"]],
      },
    ],
  },
  "2025":{
    ISNP:[
      {
      category: "Resumen del plan",
      description: [
      [
      "Prima mensual del plan: $20.30",
      "Deducible: $0",
      "Máximo de desembolso personal anual: límite anual de $3,400 para los servicios que recibe de proveedores dentro de la red"
      ]
      ]
      },
      {
      category: "Beneficios complementarios",
      description: [
      [
      "Dental: Usted paga $0 por los servicios cubiertos por Medicare. Su plan cubre hasta $3,650.00 asignación cada año ($912.50 por trimestre)",
      "Examen de la vista de rutina (cada 12 meses): N/A",
      "Audífonos: 20 % de coaseguro",
      "Beneficio de acondicionamiento físico Silver&Fit®: N/A",
      "Atención quiropráctica: 20 % de coaseguro",
      "Acupuntura: N/A",
      "Artículos de venta libre (OTC): hasta $350 por trimestre"
      ]
      ]
      },
      {
      category: "Visitas al médico",
      description: [
      [
      "Visita al médico de atención primaria: $0",
      "Visita al especialista: médicos dentro y fuera de la red: Usted paga un coseguro del 20 %",
      "Atención preventiva: $0",
      "Servicios de laboratorio/radiografías: Usted paga un coseguro del 20 % por los siguientes servicios:   Servicios de radiología diagnóstica (como resonancias magnéticas, tomografías computarizadas)   Pruebas y procedimientos de diagnóstico   Servicios de laboratorio   Radiografías para pacientes ambulatorios   Servicios de radiología terapéutica (como tratamiento de radiación para el cáncer)",
      "Radiología de diagnóstico (p. ej., resonancias magnéticas): paga un coseguro del 20 % por los siguientes servicios:   Servicios de radiología de diagnóstico (como resonancias magnéticas, tomografías computarizadas)   Pruebas y procedimientos de diagnóstico   Servicios de laboratorio   Radiografías para pacientes ambulatorios   Servicios de radiología terapéutica (como tratamiento de radiación para el cáncer)"
      ]
      ]
      },
      {
      category: "Visitas al hospital y emergencias",
      description: [
      [
      'Cobertura hospitalaria para pacientes internados: deducible de $1632 Días 1 a 60: copago de $0 Días 61 a 90: copago de $408 por día Días 91 en adelante: copago de $816 por cada uno "de por vida "Día de reserva" después del día 90 para cada período de beneficio (hasta 60 días durante su vida).  Más allá de un día de reserva de por vida; todos los costos',
      'Cobertura hospitalaria para pacientes ambulatorios: 20% de coaseguro',
      'Atención de emergencia: Usted paga un coaseguro del 20% (hasta $120 por visita)   No pagará este monto si es admitido en el hospital dentro de los 3 días por la misma condición.',
      'Servicios de urgencia: Usted paga un coaseguro del 20% (hasta $65 por visita)   No pagará este monto si es admitido en el hospital dentro de los 3 días por la misma condición.'
      ]
      ]
      },
      {
      category: "Medicamentos de la Parte D de Medicare: cobertura inicial",
      description: [
      [
      "Venta minorista/por correo:",
      "Nivel 1: 25 % de coaseguro"
      ]
      ]
      }
      ],
    ESNP: [
      {
      category: "Resumen del plan",
      description: [
      [
      "Prima mensual del plan: $20.30",
      "Deducible: $0",
      "Máximo de desembolso personal anual: límite anual de $3,400 para los servicios que recibe de proveedores dentro de la red"
      ]
      ]
      },
      {
      category: "Beneficios complementarios",
      description: [
      [
      "Dental: Usted paga $0 por los servicios cubiertos por Medicare. Su plan cubre hasta $3,450.00 asignación cada año ($862.50 por trimestre)",
      "Examen de la vista de rutina (cada 12 meses): N/A",
      "Audífonos: 20 % de coaseguro",
      "Beneficio de acondicionamiento físico Silver&Fit®: N/A",
      "Atención quiropráctica: 20 % de coaseguro",
      "Acupuntura: N/A",
      "Artículos de venta libre (OTC): copago de $0.00 por medicamentos sin receta, de venta libre y artículos relacionados con la salud, hasta $40 por mes."
      ]
      ]
      },
      {
      category: "Visitas al médico",
      description: [
      [
      "Visita al médico de atención primaria: $0",
      "Visita al especialista: 20 % de coseguro",
      "Atención preventiva: $0",
      "Servicios de laboratorio/radiografías: pagas un coseguro del 20 % por los siguientes servicios:  Servicios de radiología diagnóstica (como resonancias magnéticas, tomografías computarizadas)  Pruebas y procedimientos de diagnóstico  Servicios de laboratorio  Radiografías para pacientes ambulatorios  Servicios de radiología terapéutica (como radioterapia para el cáncer)",
      "Radiología diagnóstica (p. ej., resonancias magnéticas): pagas un coseguro del 20 % por los siguientes servicios A continuación:  Servicios de radiología diagnóstica (como resonancias magnéticas, tomografías computarizadas)  Pruebas y procedimientos de diagnóstico  Servicios de laboratorio  Radiografías para pacientes ambulatorios  Servicios de radiología terapéutica (como tratamiento de radiación para el cáncer)"
      ]
      ]
      },
      {
      category: "Visitas al hospital y emergencias",
      description: [
      [
      'Cobertura hospitalaria para pacientes internados: deducible de $1632 Días 1 a 60: copago de $0 Días 61 a 90: copago de $408 por día  Días 91 en adelante: copago de $816 por cada "día de reserva de por vida" después del día 90 por cada período de beneficio (hasta 60 días durante su vida).  Más de un día de reserva de por vida; todos los costos',
      "Cobertura hospitalaria para pacientes ambulatorios: 20% de coseguro",
      "Atención de emergencia: Usted paga un coseguro del 20% (hasta $120 por visita)  No pagará este monto si es admitido en el hospital dentro de los 3 días por la misma afección.",
      "Servicios de urgencia: Usted paga un coseguro del 20% (hasta $65 por visita)  No pagará este monto si es admitido en el hospital dentro de los 3 días por la misma afección.",
      ]
      ]
      },
      {
      category: "Medicamentos de la Parte D de Medicare: cobertura inicial",
      description: [
      [
      "Venta minorista/por correo:",
      "Nivel 1: 25 % de coaseguro"
      ]
      ]
      }
      ],
    DSNV1: [
      {
      category: "Descripción general del plan",
      description: [
      [
      "Prima mensual del plan: $20",
      "Deducible: $0",
      "Máximo de desembolso personal anual: $0"
      ]
      ]
      },
      {
      category: "Beneficios complementarios",
      description: [
      [
      "Dental: subsidio de $4,660 por año",
      "Examen de la vista de rutina (cada 12 meses): $400.00 por año",
      "Audífonos: $1000 por año",
      "Beneficio de acondicionamiento físico Silver&Fit®: N/A",
      "Atención quiropráctica: $0",
      "Acupuntura: $0",
      "Artículos de venta libre (OTC): $110.00/mes"
      ]
      ]
      },
      {
      category: "Visitas al médico",
      description: [
      [
      "Visita al médico de atención primaria: $0",
      "Especialista visita: $0",
      "Atención preventiva: $0",
      "Servicios de laboratorio/radiografías: $0",
      "Radiología diagnóstica (p. ej., resonancias magnéticas): $0"
      ]
      ]
      },
      {
      category: "Visitas al hospital y emergencias",
      description: [
      [
      "Cobertura hospitalaria para pacientes internados: $0",
      "Cobertura hospitalaria para pacientes ambulatorios: $0",
      "Atención de emergencia: $0",
      "Servicios de urgencia: $0"
      ]
      ]
      },
      {
      category: "Medicamentos de la Parte D de Medicare: cobertura inicial",
      description: [
      [
      "Venta minorista/por correo:",
      "Nivel 1: 25 % de coseguro"
      ]
      ]
      }
      ],
    DSNV2: [
      {
      category: "Descripción general del plan",
      description: [
      [
      "Prima mensual del plan: $20",
      "Deducible: $0",
      "Máximo de desembolso personal anual: $0"
      ]
      ]
      },
      {
      category: "Beneficios complementarios",
      description: [
      [
      "Dental: subsidio de $4,380 por año",
      "Examen de la vista de rutina (cada 12 meses): $400.00 por año",
      "Audífonos: $1000 por año",
      "Beneficio de acondicionamiento físico Silver&Fit®: N/A",
      "Atención quiropráctica: $0",
      "Acupuntura: $0",
      "Artículos de venta libre (OTC): $85.00/mes"
      ]
      ]
      },
      {
      category: "Visitas al médico",
      description: [
      [
      "Visita al médico de atención primaria: $0",
      "Especialista visita: $0",
      "Atención preventiva: $0",
      "Servicios de laboratorio/radiografías: $0",
      "Radiología diagnóstica (p. ej., resonancias magnéticas): $0"
      ]
      ]
      },
      {
      category: "Visitas al hospital y emergencias",
      description: [
      [
      "Cobertura hospitalaria para pacientes internados: $0",
      "Cobertura hospitalaria para pacientes ambulatorios: $0",
      "Atención de emergencia: $0",
      "Servicios de urgencia: $0"
      ]
      ]
      },
      {
      category: "Medicamentos de la Parte D de Medicare: cobertura inicial",
      description: [
      [
      "Venta minorista/por correo:",
      "Nivel 1: 25 % de coseguro"
      ]
      ]
      }
      ],
    DSNV3: [
      {
      category: "Resumen del plan",
      description: [
      [
      "Prima mensual del plan: $20",
      "Deducible: $0",
      "Máximo de desembolso personal anual: $0"
      ]
      ]
      },
      {
      category: "Beneficios complementarios",
      description: [
      [
      "Dental: subsidio de $4100 por año",
      "Examen de la vista de rutina (cada 12 meses): $400.00 por año",
      "Audífonos: $1000 por año",
      "Beneficio de acondicionamiento físico Silver&Fit®: N/A",
      "Atención quiropráctica: $0",
      "Acupuntura: $0",
      "Artículos de venta libre (OTC): $85.00/mes"
      ]
      ]
      },
      {
      category: "Visitas al médico",
      description: [
      [
      "Visita al médico de atención primaria: $0",
      "Especialista visita: $0",
      "Atención preventiva: $0",
      "Servicios de laboratorio/radiografías: $0",
      "Radiología diagnóstica (p. ej., resonancias magnéticas): $0"
      ]
      ]
      },
      {
      category: "Visitas al hospital y emergencias",
      description: [
      [
      "Cobertura hospitalaria para pacientes internados: $0",
      "Cobertura hospitalaria para pacientes ambulatorios: $0",
      "Atención de emergencia: $0",
      "Servicios de urgencia: $0"
      ]
      ]
      },
      {
      category: "Medicamentos de la Parte D de Medicare: cobertura inicial",
      description: [
      [
      "Venta minorista/por correo:",
      "Nivel 1: 25 % de coseguro"
      ]
      ]
      }
      ],
  },
  };
  //Below logic can be reutilized to format spanish data for all Vanilla customers,
  //Just like ILS.js create respective files for each vanilla customer for simplicity,
  //After creating data like above , we can just paste below logic and bOOm
  let currentYearDataList=detailLists[yearValue]
   let keyss= Object.keys(currentYearDataList)
   keyss.forEach((d)=>{
        if(productIdArray.some((p)=>p===d)){
            detailData=[...detailData,currentYearDataList[d]]
        }
    })
    if(detailData.length>1){
        let arr=detailData.slice(1)
        arr.forEach((r)=>{
    // console.log("ts--")
            r.forEach((r1,i)=>{
            detailData[0][i]["description"]=[...detailData[0][i]["description"],r1["description"][0]]
            })
        })
    }
    return detailData[0];
};
